export const Auth_Panel_Class =
  "rounded-2xl border border-pq-border bg-pq-bg-elevated shadow-xl shadow-amber-950/10 backdrop-blur-md ring-1 ring-amber-900/5 dark:ring-amber-400/10";

export const Auth_Input_Class =
  "auth-autofill-input mt-1 w-full rounded-lg border border-pq-border-strong bg-pq-input px-3.5 py-2.5 text-sm text-pq-fg placeholder:text-pq-fg-subtle outline-none transition focus:border-amber-500 focus:ring-2 focus:ring-amber-400/30";

export const Auth_Label_Class =
  "block text-xs font-medium uppercase tracking-[0.08em] text-pq-fg-subtle";

export const Auth_Btn_Primary =
  "w-full rounded-lg bg-gradient-to-r from-amber-600 to-amber-500 px-4 py-2.5 text-sm font-semibold text-white transition hover:from-amber-500 hover:to-amber-400 disabled:cursor-not-allowed disabled:opacity-60";

export const Auth_Btn_Ghost =
  "font-medium text-amber-800 underline decoration-amber-600/40 underline-offset-2 transition hover:text-amber-950 disabled:cursor-not-allowed disabled:opacity-50 dark:text-amber-300 dark:hover:text-amber-200";

export const Auth_Tab_Active = "bg-pq-bg-soft text-amber-950 dark:text-amber-100";
export const Auth_Tab_Idle = "text-pq-fg-muted hover:bg-pq-bg-soft hover:text-pq-fg";

export const Auth_Alert_Error =
  "rounded-lg border border-red-300 bg-red-50 px-3.5 py-2.5 text-sm text-red-800 dark:border-red-500/40 dark:bg-red-950/40 dark:text-red-200";

export const Auth_Alert_Info =
  "rounded-lg border border-amber-300 bg-pq-bg-soft px-3.5 py-2.5 text-sm text-amber-950 dark:border-amber-500/40 dark:text-amber-100";
